module.exports = __webpack_public_path__ + "img/dummy5.814f250.jpg";